import { combineReducers } from 'redux';
import * as types from './constants';

function listReducer(state = [], action) {
  switch (action.type) {
    case types.GET_SHOPS:
      return action.response.result;
    default:
      return state;
  }
}

function byId(state = [], action) {
  switch (action.type) {
    case types.GET_SHOPS:
      return {
        ...state,
        ...action.response.entities.shops,
      };
    default:
      return state;
  }
}

export default combineReducers({
  list: listReducer,
  byId,
});
